import { FC } from 'react';
import SecondAppBar from '../header/appBars/desktop/SecondAppBar';

const Layout: FC = () => {
  return (
    <>
      {/* <FirstAppBar /> */}
      {/* Routes for the Layout are inside the SecondAppBar component */}
      <SecondAppBar />
    </>
  );
};

export default Layout;
